import { AdditionalMessageDisplay } from "./components/AdditionalMessageDisplay";
import { RFxMailLayout } from "./components/RFxMailLayout";
import { EmailContentProps } from "./types/EmailContent.interface";

export const RFxInvitationEmailContent: React.FC<EmailContentProps> = ({
	rfxMail,
}) => {
	const emailData = rfxMail?.emailData;

	if (!emailData) {
		return null;
	}

	const $owner_company_name = emailData.owner_company_name;
	const $supplier_name = emailData.supplier_name;
	const $rfx_type = emailData.rfx_type;
	const $additional_message = emailData.additional_message;
	const type_project = rfxMail.rfx_type_name_project_name();
	const deadline = rfxMail.deadline_date_time(true);
	const link_to_rfx = rfxMail.link_to_rfx();

	const tdStyle = {
		fontFamily: "Arial, sans-serif",
		fontSize: "16px",
		lineHeight: "24px",
		color: "#374151",
		paddingBottom: "20px",
	};

	return (
		<RFxMailLayout
			$supplier_contact_name={emailData.supplier_contact_name}
			$contact={emailData.contact}
			rfx_type={emailData.rfx_code}
			project_name={emailData.project_name}
			rfx_title={emailData.rfx_title}
		>
			<tr>
				<td style={tdStyle}>
					<b>{$owner_company_name ?? "[RFx Creator Company Name]"}</b> has
					invited {$supplier_name ?? "[Recipient Company Name]"} to participate
					in a {type_project}.
					<br />
					<br />
					Your expertise and experience could be a valuable contribution to this
					project.
				</td>
			</tr>
			<tr>
				<td style={tdStyle}>
					You can preview the invitation via this link: {link_to_rfx}
					<br />
					<br />
					Please <span className="font-bold italic">accept</span> or{" "}
					<span className="font-bold italic">decline</span> as soon as possible.
					Once you accept, you can start your submission.
				</td>
			</tr>
			<tr>
				<td style={tdStyle}>
					The submission deadline for this request is:
					<div style={{ marginTop: "20px" }}>
						<b>{deadline}</b>
					</div>
				</td>
			</tr>
			<tr>
				<td style={tdStyle}>
					Should you have any questions or require further information, feel
					free to contact me directly.
				</td>
			</tr>
			<AdditionalMessageDisplay additional_message={$additional_message} />
			<tr>
				<td style={tdStyle}>
					Thank you for considering this opportunity. We look forward to your
					response.
				</td>
			</tr>
		</RFxMailLayout>
	);
};
